import { tokens } from "lib/colors"
import { useContext } from "react"
import { LanguageContext } from "context/LanguageContext"
import Text from "lib/components/Text"
import Icons from "lib/components/Icons"
import Link from "next/link"
import { gtmEvent } from "lib/gtm"
import ColoredText from "@components/shared-components/ColoredText"
import Services from "./services.json"
import { scrollToTargetSection } from "../Hero"

type CorporateSolutionServicesItem = {
  id: number
  name: string
  icon: string
  type: "view" | "consult"
}

function CorporateSolutionServices() {
  const { useTranslation: t, language } = useContext(LanguageContext)

  return (
    <section className="container px-4 lg:px-0 mx-auto py-8 lg:py-[72px] bg-white">
      <div className="flex flex-col w-full items-center lg:items-start gap-4 lg:gap-8">
        <div className="w-full flex items-center justify-center">
          <Text alignText="center" weight="semibold" customClass="text-base lg:text-2xl">
            <ColoredText
              text={t("corporate_solution_product")}
              language={language}
              keywords={{
                EN: ["product"],
                ID: ["Produk"],
              }}
              color={tokens.primary.DEFAULT}
            />
          </Text>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-6">
          {Services.map((item: CorporateSolutionServicesItem) => {
            const text = t("corporate_solution_product_items")

            return (
              <div
                key={item.id}
                className="flex flex-col w-full h-full lg:min-h-[222px] drop-shadow-[0_1px_1px_rgba(0,0,0,0.15)]">
                <div className="bg-primary rounded-t-xl h-2" />
                <div className="bg-white rounded-b-xl h-full max-h-[238px] flex flex-col items-center lg:items-start gap-2 lg:gap-3 p-3 lg:p-5">
                  <div className="flex flex-row items-center gap-2">
                    <Icons pathName={item.icon} styles="w-[17px] h-4 lg:w-[42px] lg:h-[34px]" />
                    <Text weight="semibold" customClass="text-sm lg:hidden">
                      {text[item.name]?.title}
                    </Text>
                  </div>
                  <div className="flex flex-col items-center lg:items-start gap-2 h-full">
                    <Text weight="semibold" customClass="hidden lg:block text-xl">
                      {text[item.name]?.title}
                    </Text>
                    <Text customClass="text-center lg:text-start text-sm lg:text-base">
                      {text[item.name]?.description}
                    </Text>
                  </div>
                  {item.type === "view" ? (
                    <Link
                      passHref
                      legacyBehavior
                      href={
                        item.name.includes("inhouse")
                          ? "/programs/all?type=inhouse"
                          : "/programs/all?type=public_class%2Cskill_booster"
                      }>
                      <a
                        href="#replcace"
                        className="w-fit text-primary text-sm lg:text-xl hover:underline"
                        onClick={() =>
                          gtmEvent("ce_section_engagement", {
                            section_name: t("view_available_classes"),
                            button_name: t("view_available_classes"),
                          })
                        }>
                        {t("view_available_classes")}
                      </a>
                    </Link>
                  ) : (
                    <button
                      type="button"
                      onClick={() => {
                        scrollToTargetSection("top page")
                        gtmEvent("ce_section_engagement", {
                          section_name: t("consult_with_us"),
                          button_name: t("consult_with_us"),
                        })
                      }}
                      className="w-fit text-primary text-sm lg:text-xl hover:underline">
                      {t("consult_with_us")}
                    </button>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default CorporateSolutionServices
